import { render, staticRenderFns } from "./exportTipoVenta.vue?vue&type=template&id=38224a06&scoped=true"
import script from "./exportTipoVenta.vue?vue&type=script&lang=js"
export * from "./exportTipoVenta.vue?vue&type=script&lang=js"
import style0 from "./exportTipoVenta.vue?vue&type=style&index=0&id=38224a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38224a06",
  null
  
)

export default component.exports